import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Table, Button, Modal, Form } from "antd";
import "./style.css";
import { BUTTONS, FORMS, ORGANISATION_TYPE } from "../common/constants";
import { getApis, postApis, putApis } from "../common/api";
import { setOrgList } from "../../reducers/orgSlice";
import {
  AddOrgSubscriptionUrl,
  createOrganisationUrl,
  getOrgSubscriptionUrl,
  organisationsUrl,
  subscriptionComboPlansUrl,
  updateOrganisationStatusUrl,
} from "../common/endpoints";
import CreateOrganistionForm from "./form";
import { getOrganisationFormValues } from "./getOrgFormValues";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import columnsData from "./columns";
import SubscriptionModal from "./subscriptionModal";

const Organisations = () => {
  const dispatch = useDispatch()
  const orgList = useSelector((state) => state.org)?.list;
  const authToken = localStorage.getItem("authToken");
  const [modalOpen, setModalOpen] = useState(false);
  const [subscriptionDetails, setSubscriptionDetails] = useState({
    addModel: false,
    viewModel: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [organisations, setOrganisations] = useState([]);
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [form] = Form.useForm();

  const handleCancel = () => {
    setModalOpen(false);
  };

  const subscriptionModalOpen = (data) => {
    setSubscriptionDetails((prev) => ({
      ...prev,
      addModel: false,
      viewModel: true,
      loader: true,
      orgId: data?.id,
      orgName: data?.name,
    }));
    getOrgSubscriptionDetails(data);
  };

  const subscriptionModalClose = () => {
    setSubscriptionDetails((prev) => ({
      ...prev,
      viewModel: false,
      orgId: null,
      orgName: null,
    }));
  };

  const handleSwitchChange = async (id, checked) => {
    await putApis(
      updateOrganisationStatusUrl,
      {
        orgId: id,
        status: checked,
      },
      authToken
    );

    const updatedData = organisations.map((item) => {
      return item.id === id ? { ...item, status: checked } : item;
    });
    setOrganisations(updatedData);
  };

  const columns = columnsData(handleSwitchChange, subscriptionModalOpen);

  const getOrganisations = async () => {
    if(!orgList?.length){
      await getApis(organisationsUrl, {}, authToken)
      .then((response) => {
        setOrganisations(response?.data);
        dispatch(setOrgList(response?.data?.filter((org) => org.organisationType !== ORGANISATION_TYPE.ADMINISTRATOR) || []));
      })
      .catch((error) => console.log(error));
    }else{
      setOrganisations(orgList);
    }
  };

  useEffect(() => {
    getOrganisations();
    if (!subscriptionList?.length) {
      getSubscriptionPlans();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    await postApis(
      createOrganisationUrl,
      getOrganisationFormValues(values),
      authToken
    )
      .then((response) => {
        if (response?.data?.error === null) {
          toast.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => toast.error(error));
    setIsLoading(false);
    setModalOpen(false);
  };

  const getSubscriptionPlans = async () => {
    await getApis(subscriptionComboPlansUrl, {}, authToken)
      .then((response) => {
        setSubscriptionList(response?.data);
      })
      .catch((error) => console.log(error));
  };

  const subscriptionSubmit = async (values) => {
    setIsLoading(true);
    await postApis(
      AddOrgSubscriptionUrl,
      {
        comboPlanId: values?.comboPlanId,
        startDate: Math.floor(dayjs()),
        orgId: subscriptionDetails?.orgId,
      },
      authToken
    )
      .then((response) => {
        if (response?.data?.comboPlanId) {
          toast.success("Subscription Successful");
          setSubscriptionDetails((prev) => ({
            ...prev,
            addModel: false,
            viewModel: true,
            data: response.data,
          }));
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
    setIsLoading(false);
  };

  const getOrgSubscriptionDetails = async (data) => {
    await getApis(getOrgSubscriptionUrl + data?.id, {}, authToken)
      .then((response) => {
        let data = null;
        if (response?.data?.length) {
          data = response.data.find((sub) => !sub?.endDate);
        }
        setSubscriptionDetails((prev) => ({ ...prev, loader: false, data }));
      })
      .catch((error) => {
        toast.error(error);
        setSubscriptionDetails((prev) => ({ ...prev, loader: false }));
      });
  };

  return (
    <>
      <Row justify="space-between" className="flex-center">
        <Col span={4} className="head">
          Organisations
        </Col>
        <Col span={3}>
          <Button type="primary" onClick={() => setModalOpen(true)}>
            {BUTTONS.ADD_NEW}
          </Button>
        </Col>
      </Row>
      <Row justify="center" className="mt1">
        <Col span={24}>
          <Table
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={organisations}
            pagination={organisations.length > 10 ? { pageSize: 10 } : false}
            scroll={{ x: "100%" }}
          />
        </Col>
      </Row>
      <Modal
        title={FORMS.ORGANISATIONS.HEADER}
        centered
        open={modalOpen}
        onOk={form.submit}
        onCancel={handleCancel}
        footer={null}
      >
        <CreateOrganistionForm
          handleSubmit={handleSubmit}
          isLoading={isLoading}
        />
      </Modal>
      <Modal
        title={subscriptionDetails?.orgName + " Subscription Details"}
        centered
        className="view-subscription-model"
        open={subscriptionDetails?.viewModel}
        onCancel={subscriptionModalClose}
        footer={null}
      >
        <SubscriptionModal
          isLoading={isLoading}
          subscriptionList={subscriptionList}
          subscriptionSubmit={subscriptionSubmit}
          subscriptionDetails={subscriptionDetails}
          setSubscriptionDetails={setSubscriptionDetails}
        />
      </Modal>
    </>
  );
};

export default Organisations;
